import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { 
  getRestoLogin, 
  getToken, 
  // getPermissions 
} from "./Helpers/Utils/Common";
import { Navigate } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { toastStyle } from "./Helpers/Utils/Common";

import "./Assets/Images/FontAwesomeIcons";
import "./App.css";
import "../src/cssFiles/CommonStyles.css";
import "../src/Helpers/Utils/Common.css";

/** PAGES **/
import Ordering from "./Pages/OrderingPage/OrderingPage";
import LoginAdmin from "./Pages/LoginAdmin/LoginAdmin";
import UserManager from "./Pages/UserManager/UserManager";
import MenuManager from "./Pages/MenuManager/MenuManager";
import Inventory from "./Pages/MenuManager/Inventory";
import CategoryManager from "./Pages/CategoryManager/CategoryManager";

import Payment from "./Pages/Payment/Payment";
import CashCount from "./Pages/CashCount/CashCount";
import Sales from "./Pages/Report/Sales";
import CashCounts from "./Pages/Report/CashCounts";
import ViewCashCount from "./Pages/CashCount/ViewCashCount";
import Discount from "./Pages/Discount/Discount";
import AllTables from "./Pages/Tables/AllTables";
import ItemHistory from "./Pages/Report/ItemHistory";
import XReading from "./Pages/Report/XReading";
import ZReading from "./Pages/Report/ZReading";
import DailySales from "./Pages/Report/DailySales";
import SeniorDiscounts from "./Pages/Report/SeniorDiscounts";
import PWDDiscounts from "./Pages/Report/PWDDiscounts";
import OtherDiscounts from "./Pages/Report/OtherDiscount";
import AuditTrails from "./Pages/Report/AuditTrails";
import CancelledSI from "./Pages/Report/CancelledSI";
import Ejournal from "./Pages/Report/Ejournal";
import InventoryManager from "./Pages/MenuManager/InventoryManager";
import CategoryReport from "./Pages/Report/CategoryReport";
import PaymentReport from "./Pages/Report/Payments";
import RestoItemSalesReport from "./Pages/Report/RestoItemSalesReport";
import ClockReport from "./Components/ClockReports";

function App() {
  //APP NAME
  document.title = "ORDERING SYSTEM";
  document.body.style = "background: #ffffff;";
  const token = getToken();
  const restoType = getRestoLogin();
  // const userPermission = getPermissions();

  return (
    <div className="page">
      <Toaster
        position="top-right"
        reverseOrder={false}
        toastOptions={{ style: { toastStyle } }}
      />
      <Router>
        <Routes>
          <Route path="/" element={<LoginAdmin />} />
          <Route
            path="/orderingpage"
            // element={token && userPermission?.includes("ORP") ? <Ordering /> : <Navigate to="/" />}
            element={token ? <Ordering /> : <Navigate to="/" />}
          />
          <Route
            path="/userManager"
            // element={token && userPermission?.includes("USR") ? <UserManager /> : <Navigate to="/" />}
            element={token  ? <UserManager /> : <Navigate to="/" />}
          />
          <Route
            path="/menuManager"
            // element={token && userPermission?.includes("MEN") ? <MenuManager /> : <Navigate to="/" />}
            element={token ? <MenuManager /> : <Navigate to="/" />}
          />
          <Route
            path="/inventory/:id"
            // element={token && userPermission?.includes("MEN") ? <Inventory /> : <Navigate to="/" />}
            element={token ? <Inventory /> : <Navigate to="/" />}
          />
          <Route
            path="/receiving-report"
            // element={token && userPermission?.includes("RCR") ? <InventoryManager /> : <Navigate to="/" />}
            element={token ? <InventoryManager /> : <Navigate to="/" />}
          />
          <Route
            path="/categoryManager"
            // element={token && userPermission?.includes("CAT") ? <CategoryManager /> : <Navigate to="/" />}
            element={token ? <CategoryManager /> : <Navigate to="/" />}
          />

          <Route
            path="/discountsManager"
            // element={token && userPermission?.includes("DIS") ? <Discount /> : <Navigate to="/" />}
            element={token ? <Discount /> : <Navigate to="/" />}
          />
          <Route
            path="/closedinvoices"
            // element={token && userPermission?.includes("CLI") ? <AllTables /> : <Navigate to="/" />}
            element={token ? <AllTables /> : <Navigate to="/" />}
          />
          <Route
            path="/add-payment/:orderID"
            // element={token && userPermission?.includes("ADP") ? <Payment /> : <Navigate to="/" />}
            element={token ? <Payment /> : <Navigate to="/" />}
          />

          <Route
            path="/add-cash-count"
            // element={token && userPermission?.includes("ACC") ? <CashCount /> : <Navigate to="/" />}
            element={token ? <CashCount /> : <Navigate to="/" />}
          />

          <Route
            path="/sales-report"
            // element={token && userPermission?.includes("SAL") ? <Sales /> : <Navigate to="/" />}
            element={token ? <Sales /> : <Navigate to="/" />}
          />

          <Route
            path="/item-history-report"
            // element={token && userPermission?.includes("ITH") ? <ItemHistory /> : <Navigate to="/" />}
            element={token ? <ItemHistory /> : <Navigate to="/" />}
          />
          <Route
            path="/cash-counts-report"
            // element={token && userPermission?.includes("CSC") ? <CashCounts /> : <Navigate to="/" />}
            element={token ? <CashCounts /> : <Navigate to="/" />}
          />

          <Route
            path="/category-report"
            // element={token && userPermission?.includes("CTR") ? <CategoryReport /> : <Navigate to="/" />}
            element={token ? <CategoryReport /> : <Navigate to="/" />}
          />

          <Route
            path="/payment-report"
            // element={token && userPermission?.includes("PMR") ? <PaymentReport /> : <Navigate to="/" />}
            element={token ? <PaymentReport /> : <Navigate to="/" />}
          />
          <Route
            path="/resto-item-sales-report"
            element={
              // token && restoType === "dreamnest" && userPermission?.includes("RIS") ? (
              token && restoType === "dreamnest" ? (
                <RestoItemSalesReport />
              ) : (
                <Navigate to="/" />
              )
            }
          />

          <Route
            path="/cash-counts-report/view/:id"
            // element={token && userPermission?.includes("CSC") ? <ViewCashCount /> : <Navigate to="/" />}
            element={token ? <ViewCashCount /> : <Navigate to="/" />}
          />

          <Route
            path="/senior-discounts-sales-report"
            // element={token && userPermission?.includes("SCS") ? <SeniorDiscounts /> : <Navigate to="/" />}
            element={token ? <SeniorDiscounts /> : <Navigate to="/" />}
          />

          <Route
            path="/pwd-discounts-sales-report"
            // element={token && userPermission?.includes("PWD") ? <PWDDiscounts /> : <Navigate to="/" />}
            element={token ? <PWDDiscounts /> : <Navigate to="/" />}
          />

          <Route
            path="/other-discounts-sales-report"
            // element={token && userPermission?.includes("ODS") ? <OtherDiscounts /> : <Navigate to="/" />}
            element={token ? <OtherDiscounts /> : <Navigate to="/" />}
          />

          <Route
            path="/audit-trails-report"
            // element={token && userPermission?.includes("ADT") ? <AuditTrails /> : <Navigate to="/" />}
            element={token ? <AuditTrails /> : <Navigate to="/" />}
          />

          <Route
            path="/cancelled-report"
            // element={token && userPermission?.includes("CCR") ? <CancelledSI /> : <Navigate to="/" />}
            element={token ? <CancelledSI /> : <Navigate to="/" />}
          />

          <Route
            path="/ejournal-report"
            // element={token && userPermission?.includes("EJO") ? <Ejournal /> : <Navigate to="/" />}
            element={token ? <Ejournal /> : <Navigate to="/" />}
          />

          <Route
            path="/x-reading-report"
            // element={token && userPermission?.includes("XRE") ? <XReading /> : <Navigate to="/" />}
            element={token ? <XReading /> : <Navigate to="/" />}
          />

          <Route
            path="/z-reading-report"
            // element={token && userPermission?.includes("ZRE") ? <ZReading /> : <Navigate to="/" />}
            element={token ? <ZReading /> : <Navigate to="/" />}
          />
          <Route
            path="/daily-sales-report"
            element={token ? <DailySales /> : <Navigate to="/" />}
          />

          {/*  FOR TESTING RA NIII */}
          {/* <Route
            path="/z-reading-report"
            element={token ? <ZReading /> : <Navigate to="/" />}
          /> */}

          {/* <Route
            path="/financial-report"
            element={token && userPermission?.includes("FNR") ? <FinancialReport /> : <Navigate to="/" />}
          /> */}
        </Routes>
      </Router>
      <ClockReport/>
    </div>
  );
}

export default App;
